import { ECompatibilityReportType } from 'affiny-core/modules/api/models/member/member.types';
import { compatibilityReportActions } from 'affiny-core/modules/compatibilityReport/actions';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export const useDispatchGetCompatibilityReport = (
  accountId: string,
  reportType: ECompatibilityReportType
) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      compatibilityReportActions.getCompatibilityReport({
        accountId,
        reportType: reportType || 'value',
      })
    );
  }, []);
};
